var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBug = function SvgBug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    strokeLinejoin: "round",
    style: {
      color: "currentcolor"
    },
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m2.73 1.087.186.726a5.24 5.24 0 0 0 1.275 2.3C5.108 2.82 6.474 2 8 2s2.892.82 3.81 2.114a5.24 5.24 0 0 0 1.276-2.301l.187-.726 1.452.374-.187.726a6.75 6.75 0 0 1-1.994 3.305C12.837 6.255 13 7.105 13 8h1.5v1.5h-1.658a6.6 6.6 0 0 1-.812 2.052l1.555.777.415.207V15h-1.5v-1.537l-1.439-.719C10.216 13.531 9.153 14 8 14s-2.215-.469-3.061-1.256l-1.439.72V15H2v-2.464l.415-.207 1.555-.777A6.6 6.6 0 0 1 3.158 9.5H1.5V8H3c0-.896.164-1.746.457-2.509a6.75 6.75 0 0 1-1.993-3.304l-.187-.726zM4.5 8c0-.58.08-1.115.223-1.598a6.7 6.7 0 0 0 2.527.807v5.179C5.816 11.962 4.5 10.346 4.5 8m4.25 4.388c1.434-.426 2.75-2.042 2.75-4.388 0-.58-.08-1.114-.223-1.597a6.7 6.7 0 0 1-2.527.806zM8.001 5.75c.96 0 1.858-.257 2.633-.707C9.95 4.06 8.955 3.5 8 3.5s-1.95.559-2.633 1.542c.774.45 1.674.708 2.634.708",
    clipRule: "evenodd"
  })));
};
export default SvgBug;